import _toConsumableArray from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
export function getAxisConfig(property, config, channel, orient, scaleType) {
  // configTypes to loop, starting from higher precedence
  var configTypes = [].concat(_toConsumableArray(scaleType === 'band' ? ['axisBand'] : []), [channel === 'x' ? 'axisX' : 'axisY'], _toConsumableArray(orient ? ['axis' + orient.substr(0, 1).toUpperCase() + orient.substr(1)] : []), ['axis']);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = configTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var configType = _step.value;

      if (config[configType] && config[configType][property] !== undefined) {
        return config[configType][property];
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return undefined;
}